import { RocheUIAddToCalendar } from '@repo/roche-ui';
import React, { FC } from 'react';
import { useTranslation } from '../../hooks/use-translation';
import { createRocheButtonTrackingObject, handleRocheButtonOnClick } from '../../helpers/roche-button-tracking';

export type RocheEventItem = {
  eventTitle: string;
  description: string;
  startDate: string;
  endDate: string;
};
interface RocheAddToCalendarProps {
  eventItem: RocheEventItem;
}

export const RocheAddToCalendar: FC<RocheAddToCalendarProps> = ({ eventItem }: RocheAddToCalendarProps) => {
  const heading = useTranslation('select your calendar');
  const icsLabel = useTranslation('ICS File');
  const googleCalendarLabel = useTranslation('Google Calendar');
  const outlookOnlineLabel = useTranslation('Outlook Online');

  return (
    <RocheUIAddToCalendar
      heading={heading}
      icsLabel={icsLabel}
      googleCalendarLabel={googleCalendarLabel}
      outlookOnlineLabel={outlookOnlineLabel}
      eventTitle={eventItem.eventTitle}
      description={eventItem.description}
      startDate={eventItem.startDate}
      endDate={eventItem.endDate}
      onCalendarLinkClick={(clickEvent, text, href) => {
        const trackingData = createRocheButtonTrackingObject(text, href);
        handleRocheButtonOnClick(clickEvent, trackingData);
      }}
    />
  );
};
